import React from "react";
import { number, string } from "prop-types";

import "./comment.m.css";

const Comment = ({ width = 18, height = 18, text = "Comments", className = "" }) => (
  <div styleName="wrapper" className={className}>
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 18 16">
      <defs />
      <g fill="#fff">
        <path d="M17 4h-2v6a1 1 0 01-1 1H8l-3 2h6l4 3h1v-3h1a1 1 0 001 0V5a1 1 0 00-1-1z" data-name="Path 133509" />
        <path d="M14 0H1a1 1 0 00-1 1v9a1 1 0 001 0h2v4l5-4h6V1a1 1 0 000-1z" data-name="Path 133510" />
      </g>
    </svg>
    <span styleName="title" className="title">
      {text}
    </span>
  </div>
);

Comment.propTypes = {
  width: number,
  height: number,
  text: string,
  className: string,
};

export default Comment;
